import React, { useState } from "react";
import { ReactComponent as CarteleraGacSVG } from "assets/icons/CarteleraGAC.svg";
import { ReactComponent as TicketSVG } from "assets/icons/Tickets.svg";
import { ReactComponent as CrmSVG } from "assets/icons/CRM.svg";
import { ReactComponent as VicidialSVG } from "assets/icons/Vicidial.svg";
import { ReactComponent as TicketsInforme } from "assets/icons/TicketsInforme.svg";
import { ReactComponent as Folder } from "assets/icons/folder.svg";
import { ReactComponent as Profile } from "assets/icons/Perfil.svg";
import { ReactComponent as DirectoryGAC } from "assets/icons/DirectorioGAC.svg";
import { ReactComponent as RRHH } from "assets/icons/rrhh.svg";
import { ReactComponent as CreateNews } from "assets/icons/create-new.svg";
import { ReactComponent as AddBanner } from "assets/icons/folder-add.svg";
import { ReactComponent as Config } from "assets/icons/Ajustes.svg";

import { NavLink } from "react-router-dom";
import { useUserInfo } from "hooks/useUserInfo";

import "styles/aside.css";

const Aside = () => {
  const [vicidialOpen, setVicidialOpen] = useState(false);
  const { data: user } = useUserInfo();

  const toggleVicidial = () => {
    setVicidialOpen((prev) => !prev);
  };

  return (
    <nav className="aside" aria-label="Menú principal">
      <ul className="asideList">
        {/* Perfil */}
        <li className="asideItem">
          <NavLink
            to="profile"
            className={({ isActive }) =>
              `asideLink ${isActive ? "active" : ""}`
            }
          >
            <Profile className="asideIcon" />
            <span>Perfil</span>
          </NavLink>
        </li>

        {/* Cartelera */}
        <li className="asideItem">
          <NavLink
            to="dashboard/Comunicación Interna"
            className={({ isActive }) =>
              `asideLink ${isActive ? "active" : ""}`
            }
          >
            <CarteleraGacSVG className="asideIcon" />
            <span>Cartelera GAC</span>
          </NavLink>
        </li>

        {/* Directorio */}
        <li className="asideItem">
          <NavLink
            to="directory"
            className={({ isActive }) =>
              `asideLink ${isActive ? "active" : ""}`
            }
          >
            <DirectoryGAC className="asideIcon" />
            <span>Directorio GAC</span>
          </NavLink>
        </li>

        {/* Evaluación */}
        <li className="asideItem">
          <NavLink
            to="google-form"
            className={({ isActive }) =>
              `asideLink ${isActive ? "active" : ""}`
            }
          >
            <DirectoryGAC className="asideIcon" />
            <span>Evaluación</span>
          </NavLink>
        </li>

        {/* Tickets */}
        <li className="asideItem">
          <NavLink
            to="add-ticket"
            className={({ isActive }) =>
              `asideLink ${isActive ? "active" : ""}`
            }
          >
            <TicketSVG className="asideIcon" />
            <span>Tickets</span>
          </NavLink>
        </li>

        {/* Documentos RRHH */}
        <li className="asideItem">
          <NavLink
            to="human-resources"
            className={({ isActive }) =>
              `asideLink ${isActive ? "active" : ""}`
            }
          >
            <Folder className="asideIcon" />
            <span>Documentos RRHH</span>
          </NavLink>
        </li>

        {/* Vicidial */}
        <li className="asideItem">
          <button
            type="button"
            className={`asideLink asideButton ${
              vicidialOpen ? "expanded" : ""
            }`}
            onClick={toggleVicidial}
            aria-expanded={vicidialOpen}
          >
            <VicidialSVG className="asideIcon" />

            <span>Vicidial</span>

            <span className="asideArrow">{vicidialOpen ? "−" : "+"}</span>
          </button>

          {vicidialOpen && (
            <ul className="asideSubmenu">
              <li>
                <a
                  href="http://alianzacol-web.ccxentral.com:81/valid8.php"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Validación
                </a>
              </li>

              <li>
                <a
                  href="https://alianzacol-ast1.ccxentral.com:8089/ws"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Extensión
                </a>
              </li>

              <li>
                <a
                  href="https://alianzacol-web.ccxentral.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ingreso
                </a>
              </li>
            </ul>
          )}
        </li>

        {/* CRM */}
        <li className="asideItem">
          <a
            href="https://grupoalianzacolombia.net/scr/adm/ent"
            target="_blank"
            rel="noopener noreferrer"
            className="asideLink"
          >
            <CrmSVG className="asideIcon" />
            <span>CRM</span>
          </a>
        </li>

        {/* Opciones de Community Manager */}
        {user?.area === "Diseño y Tecnología" &&
          user?.cargo === "COMMUNITY MANAGER" && (
            <>
              <li className="asideItem">
                <NavLink
                  to="news98606cac-9762-11ed"
                  className={({ isActive }) =>
                    `asideLink ${isActive ? "active" : ""}`
                  }
                >
                  <CreateNews className="asideIcon" />
                  <span>Crear Publicación</span>
                </NavLink>
              </li>

              <li className="asideItem">
                <NavLink
                  to="new-banner"
                  className={({ isActive }) =>
                    `asideLink ${isActive ? "active" : ""}`
                  }
                >
                  <AddBanner className="asideIcon" />
                  <span>Crear Banner</span>
                </NavLink>
              </li>
            </>
          )}

        {/* Tickets RRHH */}
        {user?.area === "Talento Humano" && (
          <li className="asideItem">
            <NavLink
              to="tickets-resources-humans"
              className={({ isActive }) =>
                `asideLink ${isActive ? "active" : ""}`
              }
            >
              <RRHH className="asideIcon" />
              <span>Tickets RRHH</span>
            </NavLink>
          </li>
        )}

        {/* Consultar tickets */}
        {user?.area === "Diseño y Tecnología" &&
          user?.cargo === "AUXILIAR DE SOPORTE TECNICO" && (
            <li className="asideItem">
              <NavLink
                to="tickets"
                className={({ isActive }) =>
                  `asideLink ${isActive ? "active" : ""}`
                }
              >
                <TicketsInforme className="asideIcon" />
                <span>Consultar tickets</span>
              </NavLink>
            </li>
          )}

        {/* Tickets informe */}
        {user?.area === "Diseño y Tecnología" &&
          user?.cargo === "LIDER DE DISEÑO Y TIC" && (
            <li className="asideItem">
              <NavLink
                to="review-tickets"
                className={({ isActive }) =>
                  `asideLink ${isActive ? "active" : ""}`
                }
              >
                <TicketsInforme className="asideIcon" />
                <span>Tickets informe</span>
              </NavLink>
            </li>
          )}

        {/* Configuración */}
        <li className="asideItem">
          <NavLink
            to="config"
            className={({ isActive }) =>
              `asideLink ${isActive ? "active" : ""}`
            }
          >
            <Config className="asideIcon" />
            <span>Ajustes</span>
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Aside;
